import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Autoplay } from 'swiper/modules';
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay]);

jQuery(document).ready(function ($) {
    // Target your header slider elements using a standard jQuery collection loop
    $('.header-slider').each(function () {
        var $sliderContainer = $(this);

        // Only initialize if the element exists and hasn't been initialized by Swiper yet
        if ($sliderContainer.length && !$sliderContainer.hasClass('swiper-initialized')) {

            // If you are importing Swiper via ES modules/bundlers, use the constructor directly on the jQuery element node
            var supportSlider = new Swiper($sliderContainer[0], {
                loop: true,
                freeMode: true,
                slidesPerView: 'auto',
                speed: 40000,

                // Extra parameters ensuring the loop auto-starts smoothly on page load
                observer: true,
                observeParents: true,

                autoplay: {
                    delay: 0,
                    pauseOnMouseEnter: false,
                    disableOnInteraction: false,
                    waitForTransition: true,
                    stopOnLastSlide: false,
                },
            });
        }
    });
});
